<div class="esf-accordion__unit">
  <div class="esf-accordion__trigger" [class.-is-open]="isPanelOpened" (click)="isPanelOpenedChange.emit(!isPanelOpened)">
    <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
      <span class="esf-action-heading__text" i18n='Magento orders section title@@customerOverviewComponent.heading.merchandising'>Merchandising</span>
    </h4>
  </div>
  <div class="esf-accordion__target -is-open" [hidden]="!isPanelOpened">
    <div class="esf-info-tile esf-info-tile--full-width">
      <div class="esf-info-tile__content">
        <table class="esf-table" *ngIf="orders?.length">
          <thead class="esf-table__head">
            <tr class="esf-table__row">
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.date' data-label="Date">
                <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.date'>Date</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.merchandisingInvoiceNumber' data-label="Merch. order">
                <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.merchandisingInvoiceNumber'>Merch. order</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.products' data-label="Products">
                <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.products'>Products</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.quantity' data-label="Quantity">
                <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.quantity'>Quantity</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.amount' data-label="Amount">
                <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.amount'>Amount</span>
              </th>
            </tr>
          </thead>
          <tbody class="esf-table__body">
            <tr class="esf-table__row" *ngFor="let order of orders">
              <td class="esf-table__cell" data-label="Date" i18n-data-label='Table cell heading@@general.tableCellLabel.date'>
                <span class="esf-table__cell-inner">{{ order.purchaseDateTime.date | date:order.purchaseDateTime.format }}</span>
              </td>
              <td class="esf-table__cell" data-label="Invoice number" i18n-data-label='Table cell heading@@general.tableCellLabel.merchandisingInvoiceNumber'>
                <span class="esf-table__cell-inner">{{ order.invoiceNumber }}</span>
              </td>
              <td class="esf-table__cell" data-label="Products" i18n-data-label='Table cell heading@@general.tableCellLabel.products'>
                <span class="esf-table__cell-inner">{{ order.orderItems | evGroupOrderItems }}</span>
              </td>
              <td class="esf-table__cell" data-label="Quantity" i18n-data-label='Table cell heading@@general.tableCellLabel.quantity'>
                <span class="esf-table__cell-inner">{{ order.quantity }}</span>
              </td>
              <td class="esf-table__cell" data-label="Amount" i18n-data-label='Table cell heading@@general.tableCellLabel.amount'>
                <span class="esf-table__cell-inner">{{ order.fullPrice.value | currency: order.fullPrice.currency:'code' }}</span>
              </td>
            </tr>
          </tbody>
        </table>

        <section class="esf-empty-state flex-empty-state"
                 *ngIf="!orders?.length"
                 app-empty-state
                 [emptyStateIcon]="'#esf-icon-merch'"
                 [emptyStateText]="tablesTranslations.i18nNoMerchandising">
        </section>

        <div class="esf-info-tile__show-all" *ngIf="orders?.length >= 5">
          <button class="esf-button esf-button--simple" [routerLink]="['merchandising']">
            <span class="esf-button__icon-text-right-12" i18n="Action button@@general.button.showAll">Show all</span>
            <svg class="esf-icon esf-button__icon esf-button__icon-right" width="12" height="12">
              <use xlink:href="#esf-icon-arrow-right"></use>
            </svg>
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
